import type { Testimonial } from '../components/Testimonials'

/**
 * REAL TESTIMONIALS ONLY. Never invent quotes, names or ratings (FTC).
 * If an early reader received a free copy, set `disclosure` to
 * 'Early reader — received a free copy.'
 *
 * Slot guide, pre-price (§ before the pricing card):
 *  1. Economic result with a number (a budget line caught in time).
 *  2. Chaos or crisis resolved — ideally naming a specific month.
 *  3. Status / relationship change (the couple, the family, the engagement).
 *
 * While this array is empty, the page shows the "Inside the system"
 * product-proof block in its place instead of visible placeholders.
 */
export const preTestimonials: Testimonial[] = []

/**
 * Post-price slots. Each quote should name a specific component —
 * Volume 1, The Vendor Booking Order, Volume 5, the Deadline Calendar —
 * to make the pricing card's list tangible.
 */
export const postTestimonials: Testimonial[] = []
